<template>
  <h2 class="pb-2 border-bottom">Otomodeling (Non-Surgical Ear Reshaping) Services</h2>
  <div class="otomodeling-flex">
    <div class="otomodeling-content">
      <p>Otomodeling, also known as non-surgical ear reshaping, is a minimally invasive procedure designed to correct protruding ears, asymmetry, or irregular ear contours without the need for traditional otoplasty.</p>

      <h5>Who Can Benefit from Otomodeling?</h5>
      <ul>
        <li>Patients with Protruding Ears – Those who want a more balanced ear position</li>
        <li>Asymmetrical Ears – People with uneven ear shapes or sizes</li>
        <li>Mild Ear Deformities – Small irregularities that don’t require surgery</li>
        <li>Clients Seeking Non-Surgical Alternatives – Patients who want a subtle, scar-free correction</li>
      </ul>

      <h5>Otomodeling Techniques You Can Offer</h5>
      <ul>
        <li>Hyaluronic Acid Fillers for Ear Reshaping
          <ul>
            <li>Adds volume to hollow or uneven areas</li>
            <li>Improves symmetry and smooths cartilage irregularities</li>
            <li>Quick procedure with minimal downtime</li>
          </ul>
        </li>
        <li>Threads for Ear Contouring (PDO or PLLA Threads)
          <ul>
            <li>Used to reshape the ear angle and position</li>
            <li>Provides a lifting effect for a more balanced look</li>
            <li>Non-permanent but long-lasting results (12-18 months)</li>
          </ul>
        </li>
        <li>Ear Lobe Rejuvenation (Filler or PRP Therapy)
          <ul>
            <li>Restores volume to thin or sagging ear lobes</li>
            <li>Helps with earlobe wrinkles or post-earring damage</li>
            <li>Prevents earrings from tearing or stretching the lobe</li>
          </ul>
        </li>
      </ul>

      <h5>Otomodeling Procedure Overview</h5>
      <ul>
        <li>Consultation & Evaluation – Assess ear shape, symmetry, and patient goals</li>
        <li>Local Anesthesia or Numbing Cream – Ensures a comfortable procedure</li>
        <li>Injection of Fillers or Placement of Threads – Custom technique based on patient needs</li>
        <li>Immediate Results – No downtime, mild swelling for 24-48 hours</li>
        <li>Follow-up Visit</li>
      </ul>
    </div>
    <div class="otomodeling-video">
      <iframe width="320" height="568" style="max-width:100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0,0,0,0.08);" src="https://www.youtube.com/embed/9rbA47bOvms" title="YouTube Shorts: Ear Lobe Repair" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EarLobeRepairContentEn'
};
</script>

<style scoped>
.otomodeling-flex {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: 1.5rem;
}
.otomodeling-content {
  flex: 1 1 340px;
  min-width: 0;
}
.otomodeling-video {
  flex: 0 0 340px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
@media (max-width: 900px) {
  .otomodeling-flex {
    flex-direction: column;
    gap: 1.5rem;
  }
  .otomodeling-video {
    justify-content: flex-start;
    margin: 0 auto;
  }
}
</style>
